import { MouseEvent } from 'react';
import LangEnum from '../../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../../../modules/translation/TranslationContext';
import useCanChangeAdminOptions from '../../../../../../../stores/ShowUnavailableProducts/hooks/useCanChangeAdminOptions';
import { useShowUnavailableProductsStore } from '../../../../../../../stores/ShowUnavailableProducts/showUnavailableProducts.store';

export const useShowUnavailableProductsTrigger = () => {
  const { translate } = useTranslation();
  const canChangeAdminOptions = useCanChangeAdminOptions();
  const showUnavailableProducts = useShowUnavailableProductsStore(
    (state) => state.showUnavailableProducts,
  );
  const toggle = useShowUnavailableProductsStore((state) => state.toggle);

  const label = translate(LangEnum.PRODUCTS_SHOW_UNAVAILABLE_TOGGLE);

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    toggle();
  };

  return { canChangeAdminOptions, showUnavailableProducts, label, handleClick };
};
